var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "tab-nav"
  }, _vm._l(_vm.tabOptions, function (tabOption) {
    return _c('a', {
      key: tabOption.value,
      staticClass: "tab-link",
      class: _vm.tab == tabOption.value ? 'text-dark tab-link-active' : 'text-muted',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function ($event) {
          return _vm.setReassignmentTab(tabOption.value);
        }
      }
    }, [_vm._v(" " + _vm._s(tabOption.text) + " "), _c('b-badge', {
      staticClass: "ml-2",
      attrs: {
        "pill": "",
        "variant": _vm.tab == tabOption.value ? 'secondary' : 'primary'
      }
    }, [_vm._v(" " + _vm._s(_vm.tabCounts[tabOption.value]) + " ")])], 1);
  }), 0), _vm.isManager ? _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-button', {
    staticClass: "reassignment-btn",
    attrs: {
      "variant": "primary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('open-new-reassignment');
      }
    }
  }, [_vm._v(" New Reassignment ")])], 1) : _vm._e()], 1), _c('b-row', {
    staticClass: "mb-3 flex-nowrap",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('b-input-group', {
    staticClass: "d-flex"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', [_c('b-icon-search')], 1)], 1), _c('b-form-input', {
    ref: "searchInput",
    staticClass: "grow-1 p-0",
    attrs: {
      "placeholder": "Search by doctor name",
      "type": "search",
      "autocomplete": "off"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm.search.length > 0 ? _c('b-input-group-prepend', {
    staticClass: "p-0"
  }, [_c('b-input-group-text', {
    staticClass: "p-0"
  }, [_c('b-button', {
    staticClass: "border-0 align-self-center p-0",
    attrs: {
      "variant": "outline-white"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('b-icon-x-circle')], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-dropdown', {
    ref: "filterDropdown",
    attrs: {
      "right": "",
      "no-caret": "",
      "variant": "outline-secondary",
      "toggle-class": "filter-toggle rounded-pill",
      "menu-class": "filter-dropdown-menu",
      "boundary": "window"
    },
    on: {
      "show": _vm.onFilterPanelShow
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('b-icon', {
          staticClass: "mr-1",
          attrs: {
            "icon": "funnel"
          }
        }), _vm._v(" Add filter "), _vm.filters.length ? _c('b-badge', {
          staticClass: "ml-1 bg-secondary text-white",
          attrs: {
            "pill": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.filters.length) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-form', {
    staticClass: "p-4"
  }, [_vm._l(_vm.pendingFilters, function (condition, index) {
    return _c('div', {
      key: `${condition.column}-${index}`,
      staticClass: "filter-condition"
    }, [_c('b-form-select', {
      staticClass: "filter-col-column",
      attrs: {
        "options": _vm.columnOptions,
        "size": "sm"
      },
      on: {
        "change": function ($event) {
          return _vm.onColumnChange(index);
        }
      },
      model: {
        value: condition.column,
        callback: function ($$v) {
          _vm.$set(condition, "column", $$v);
        },
        expression: "condition.column"
      }
    }), _c('b-form-select', {
      staticClass: "filter-col-operator",
      attrs: {
        "options": _vm.getOperators(condition.column),
        "size": "sm"
      },
      model: {
        value: condition.operator,
        callback: function ($$v) {
          _vm.$set(condition, "operator", $$v);
        },
        expression: "condition.operator"
      }
    }), condition.column === 'status' ? _c('b-form-select', {
      staticClass: "filter-col-value",
      attrs: {
        "options": [{
          value: '',
          text: 'Select status…',
          disabled: true
        }, ..._vm.statusOptions],
        "size": "sm"
      },
      model: {
        value: condition.value,
        callback: function ($$v) {
          _vm.$set(condition, "value", $$v);
        },
        expression: "condition.value"
      }
    }) : condition.column === 'state' ? _c('b-form-select', {
      staticClass: "filter-col-value",
      attrs: {
        "options": [{
          value: '',
          text: 'Select state…',
          disabled: true
        }, ..._vm.stateOptions],
        "size": "sm"
      },
      model: {
        value: condition.value,
        callback: function ($$v) {
          _vm.$set(condition, "value", $$v);
        },
        expression: "condition.value"
      }
    }) : condition.column === 'startDate' || condition.column === 'endDate' ? _c('b-form-input', {
      staticClass: "filter-col-value",
      attrs: {
        "type": "date",
        "size": "sm"
      },
      model: {
        value: condition.value,
        callback: function ($$v) {
          _vm.$set(condition, "value", $$v);
        },
        expression: "condition.value"
      }
    }) : _c('b-form-input', {
      staticClass: "filter-col-value",
      attrs: {
        "size": "sm",
        "placeholder": "Enter value..."
      },
      model: {
        value: condition.value,
        callback: function ($$v) {
          _vm.$set(condition, "value", $$v);
        },
        expression: "condition.value"
      }
    }), _c('b-button', {
      staticClass: "filter-remove text-muted",
      attrs: {
        "variant": "link",
        "size": "sm"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeCondition(index);
        }
      }
    }, [_c('b-icon', {
      attrs: {
        "icon": "x-circle"
      }
    })], 1)], 1);
  }), _vm.pendingFilters.length === 0 ? _c('p', {
    staticClass: "filter-empty-msg text-muted"
  }, [_vm._v(" No filters added yet. ")]) : _vm._e(), _c('a', {
    staticClass: "add-condition-link text-secondary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.addCondition
    }
  }, [_vm._v(" + Add condition ")]), _c('div', {
    staticClass: "filter-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.cancelFilter
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "apply-btn",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_vm._v(" Apply ")])], 1)], 2)], 1)], 1)], 1), _vm.filters.length ? _c('div', {
    staticClass: "filter-chips"
  }, [_vm._l(_vm.filters, function (filter, index) {
    return _c('b-badge', {
      key: `${filter.column}-${filter.operator}-${String(filter.value)}-${index}`,
      staticClass: "filter-chip text-secondary",
      attrs: {
        "pill": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.formatFilterChip(filter)) + " "), _c('b-icon', {
      staticClass: "ml-1 chip-remove",
      attrs: {
        "icon": "x"
      },
      on: {
        "click": function ($event) {
          return _vm.removeFilter(index);
        }
      }
    })], 1);
  }), _c('a', {
    staticClass: "clear-all-link small text-secondary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clearAllFilters
    }
  }, [_vm._v(" Clear all ")])], 2) : _vm._e(), _c('b-table', {
    ref: "table",
    staticClass: "card-table",
    style: _vm.tableHeightStyle,
    attrs: {
      "responsive": "",
      "fixed": "",
      "show-empty": "",
      "fields": _vm.headers,
      "items": _vm.items,
      "busy": _vm.fetching,
      "sticky-header": ""
    },
    scopedSlots: _vm._u([{
      key: "table-colgroup",
      fn: function (scope) {
        return _vm._l(scope.fields, function (field) {
          return _c('col', {
            key: field.key,
            class: field.class
          });
        });
      }
    }, {
      key: "table-busy",
      fn: function () {
        return [_c('div', {
          staticClass: "table-busy-content",
          style: {
            height: `calc(100vh - ${350 + (_vm.filters.length > 0 ? 44 : 0) + 80}px)`
          }
        }, [_c('b-spinner')], 1)];
      },
      proxy: true
    }, {
      key: "empty",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center text-muted my-4"
        }, [_c('div', [_vm._v("No records found.")]), _vm.filters.length ? _c('a', {
          staticClass: "text-secondary",
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": _vm.clearAllFilters
          }
        }, [_vm._v(" Clear filters ")]) : _vm._e()])];
      },
      proxy: true
    }, {
      key: "cell(startdatestamp)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.getDate(row.item.startdatestamp)) + " ")];
      }
    }, {
      key: "cell(enddatestamp)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.getDate(row.item.enddatestamp)) + " ")];
      }
    }, {
      key: "cell(name)",
      fn: function (row) {
        return [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" Dr. " + _vm._s(row.item.firstname) + " " + _vm._s(row.item.lastname) + " ")])];
      }
    }, {
      key: "cell(assignmenttype)",
      fn: function (row) {
        return [_vm._v(" " + _vm._s(_vm.deriveReassignmentType(row.item)) + " ")];
      }
    }, {
      key: "cell(requeststatus)",
      fn: function (row) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatListingStatus(row.item).status))]), row.item.id && _vm.formatListingStatus(row.item).subStatus ? [_c('b-icon', {
          staticClass: "ml-1 status-eye",
          attrs: {
            "id": `status-eye-${row.item.id}`,
            "icon": "eye"
          }
        }), _c('b-popover', {
          attrs: {
            "target": `status-eye-${row.item.id}`,
            "triggers": "hover",
            "placement": "top",
            "boundary": "window",
            "custom-class": "status-popover"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v(" Reassignment Status ")];
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" " + _vm._s(_vm.formatListingStatus(row.item).subStatus) + " ")])] : _vm._e()];
      }
    }, {
      key: "cell(coveredstate)",
      fn: function (row) {
        return [row.item.coveredstate && row.item.coveredstate.length ? _c('div', {
          staticClass: "state-list"
        }, [_c('span', [_vm._v(_vm._s(_vm.getFirstStates(row.item.coveredstate)))]), row.item.coveredstate.length > 5 ? _c('CoreTooltip', {
          attrs: {
            "placement": "bottom"
          },
          scopedSlots: _vm._u([{
            key: "popper",
            fn: function () {
              return [_c('div', {
                staticClass: "mb-1 font-weight-bold"
              }, [_vm._v(" " + _vm._s(row.item.coveredstate.length - 5) + " more states ")]), _c('div', [_vm._v(_vm._s(_vm.getRemainingStates(row.item.coveredstate)))])];
            },
            proxy: true
          }], null, true)
        }, [_c('span', {
          staticClass: "ml-1 overflow-link text-secondary"
        }, [_vm._v("+" + _vm._s(row.item.coveredstate.length - 5) + " more")])]) : _vm._e()], 1) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" — ")])];
      }
    }, {
      key: "cell(doctorlistdetails)",
      fn: function (row) {
        return [row.item.doctorlistdetails && row.item.doctorlistdetails.length ? [_vm._l(row.item.doctorlistdetails.slice(0, 5), function (doctor) {
          return _c('div', {
            key: `${row.item.id}-${doctor.doctorid}`
          }, [_vm._v(" " + _vm._s(doctor.firstname) + " " + _vm._s(doctor.lastname) + " ")]);
        }), row.item.id && row.item.doctorlistdetails.length > 5 ? [_c('span', {
          staticClass: "overflow-link text-secondary",
          attrs: {
            "id": `doctor-more-${row.item.id}`
          }
        }, [_vm._v(" +" + _vm._s(row.item.doctorlistdetails.length - 5) + " more ")]), _c('b-popover', {
          attrs: {
            "target": `doctor-more-${row.item.id}`,
            "triggers": "hover",
            "placement": "top",
            "boundary": "window",
            "custom-class": "doctor-overflow-popover"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v(" " + _vm._s(row.item.doctorlistdetails.length - 5) + " more doctors ")];
            },
            proxy: true
          }], null, true)
        }, [_c('div', {
          staticClass: "doctor-overflow-list"
        }, _vm._l(row.item.doctorlistdetails.slice(5), function (doctor) {
          return _c('div', {
            key: doctor.doctorid
          }, [_vm._v(" " + _vm._s(doctor.firstname) + " " + _vm._s(doctor.lastname) + " ")]);
        }), 0)])] : _vm._e()] : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" — ")])];
      }
    }, {
      key: "cell(requestedby)",
      fn: function (row) {
        return [_c('span', {
          class: {
            'text-muted': !row.item.requestedbyusername
          }
        }, [_vm._v(" " + _vm._s(row.item.requestedbyusername || '—') + " ")])];
      }
    }, {
      key: "cell(notes)",
      fn: function (row) {
        return [_c('span', {
          class: {
            'text-muted': _vm.formatRequestNotes(row.item.reason) === '—'
          }
        }, [_vm._v(" " + _vm._s(_vm.formatRequestNotes(row.item.reason)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function (row) {
        return [_c('div', {
          staticClass: "actions-cell"
        }, [_vm.isManager ? [_vm.showEdit(row.item) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark",
            "pill": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('open-edit-reassignment', row.item);
            }
          }
        }, [_vm._v(" Edit ")]) : _vm._e(), _vm.showCancel(row.item) ? [_vm.isCancelReadonly(row.item) ? [_c('span', {
          staticClass: "d-inline-block",
          attrs: {
            "id": `cancel-tip-${row.item.id}`,
            "tabindex": "0"
          }
        }, [_c('b-button', {
          staticStyle: {
            "pointer-events": "none"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-dark",
            "pill": "",
            "disabled": ""
          }
        }, [_vm._v(" Cancel ")])], 1), _c('b-tooltip', {
          attrs: {
            "target": `cancel-tip-${row.item.id}`,
            "triggers": "hover",
            "boundary": "window"
          }
        }, [_vm._v(" Patients are currently being reassigned. To avoid issues with patient records and continuity of care, please wait until reassignments are completed before cancelling this request. ")])] : _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark",
            "pill": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('open-cancel-reassignment', row.item);
            }
          }
        }, [_vm._v(" Cancel ")])] : _vm._e(), _vm.showMakePermanent(row.item) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-dark",
            "pill": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('open-make-permanent', row.item);
            }
          }
        }, [_vm._v(" Make Permanent ")]) : _vm._e(), !_vm.showEdit(row.item) && !_vm.showCancel(row.item) && !_vm.showMakePermanent(row.item) ? _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(" — ")]) : _vm._e()] : _vm._e()], 2)];
      }
    }])
  }), _c('div', {
    staticClass: "py-2 d-flex justify-content-end tw-mt-10"
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_vm.total > 0 ? _c('b-pagination', {
    attrs: {
      "value": _vm.currentPage,
      "pills": "",
      "total-rows": _vm.total,
      "per-page": 25
    },
    on: {
      "page-click": _vm.handlePaginationClick
    }
  }) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };